import { DRAWER_KEY } from './drawer'

export const SERVICE_ORDER_TYPES = {
  ACTIVATION: 'ACTIVATION',
  ADDRESS_CHANGE: 'ADDRESS_CHANGE',
  REPAIR: 'REPAIR',
}

export const SERVICE_ORDER_LABEL = {
  [SERVICE_ORDER_TYPES.ACTIVATION]: 'Instalação',
  [SERVICE_ORDER_TYPES.ADDRESS_CHANGE]: 'Mudança de endereço',
  [SERVICE_ORDER_TYPES.REPAIR]: 'Reparo',
}

export const SERVICE_ORDER_DRAWER_BY_TYPE = {
  [SERVICE_ORDER_TYPES.ACTIVATION]: DRAWER_KEY.ACTIVATION_PENDING,
  [SERVICE_ORDER_TYPES.ADDRESS_CHANGE]: DRAWER_KEY.ADDRESS_CHANGE,
  [SERVICE_ORDER_TYPES.REPAIR]: DRAWER_KEY.VIRTUAL_SUPPORT,
}

export const SERVICE_ORDER_CONFIRMATION = [
  SERVICE_ORDER_TYPES.ACTIVATION,
  SERVICE_ORDER_TYPES.ADDRESS_CHANGE,
  SERVICE_ORDER_TYPES.REPAIR,
]

export const SERVICE_ORDER_STATUS = {
  ST_OS_CRIADA: 'ST_OS_CRIADA',
}

export const SO_TYPES = {
  FINISHED: 'ORDEM EXECUTADA',
}

export const SUPPORT_STATUS = {
  HAS_OS: 'HAS_OS',
  INELIGIBLE_CONTRACT: 'INELIGIBLE_CONTRACT',
  HAS_CONNECTION: 'HAS_CONNECTION',
  HAS_MASSIVE: 'HAS_MASSIVE',
  SCHEDULE_REPAIR: 'SCHEDULE_REPAIR',
  OTHER_CONNECTION_PROBLEMS: 'OTHER_CONNECTION_PROBLEMS',
  NO_MATCHING_RULE: 'NO_MATCHING_RULE',
}

export const SUPPORT_STATUS_TITLE = {
  [SUPPORT_STATUS.HAS_CONNECTION]: 'Online',
  [SUPPORT_STATUS.HAS_MASSIVE]: 'Falha na sua região',
  [SUPPORT_STATUS.SCHEDULE_REPAIR]: 'Agendar reparo',
  [SUPPORT_STATUS.OTHER_CONNECTION_PROBLEMS]: 'Verificar conexão',
  [SUPPORT_STATUS.NO_MATCHING_RULE]: 'Não foi possível continuar',
}

export const SUPPORT_STATUS_CTA_LABEL = {
  TALK_WITH_ATTENDANT: 'Falar com atendimento',
  CLOSE_DRAWER: 'Ok, entendi!',
  SCHEDULE: 'Agendar',
}

export const SUPPORT_STATUS_DRAWER_STAGES = {
  RESPONSE: 'initial',
  ERROR: 'error',
}

export const SUPPORT_CONNECTION_PROBLEMS_STEPS = [
  'Desligue o modem da tomada',
  'Aguarde 2 a 3 minutos',
  'Ligue o modem novamente',
  'Aguarde até que a luz da internet fique acesa, sem piscar.',
  'Verifique se a conexão retornou',
]
